import { render, staticRenderFns } from "./AdminContracts.vue?vue&type=template&id=bb2659ec&scoped=true&"
import script from "./AdminContracts.vue?vue&type=script&lang=js&"
export * from "./AdminContracts.vue?vue&type=script&lang=js&"
import style0 from "./AdminContracts.vue?vue&type=style&index=0&id=bb2659ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2659ec",
  null
  
)

export default component.exports